// extracted by mini-css-extract-plugin
module.exports = {"bigOverlayImageWrapper":"Ep","bigOverlayVideo":"Fp","bigOverlayImage":"Gp"};